import { getBomLineItemExtraData } from "../../utils/extracters"

export const updateUserAction = (state, index, user_action) => {
  state.bom_line_items[index].user_action = user_action
  state.board_qtys.map((board_qty) => {
    const {error_message, new_price_by_qty, new_qty_to_buy} = getBomLineItemExtraData(state.bom_line_items[index], board_qty, state.selected_board_qty)
    state.bom_line_items[index].error_message[board_qty] = error_message
    if(state.selected_board_qty === board_qty && new_price_by_qty) {
      state.bom_line_items[index].qty_to_buy[board_qty] = new_qty_to_buy
      state.bom_line_items[index].price_by_qty[board_qty] = new_price_by_qty
    }
  })
}